export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING';
export const SET_SETTINGS_FORM_SENDING = 'SET_SETTINGS_FORM_SENDING';
export const SET_SETTINGS_ERRORS = 'SET_SETTINGS_ERRORS';
export const SET_INITIAL_SETTINGS_VALUES = 'SET_INITIAL_SETTINGS_VALUES';
export const SET_BASIC_CONFIG_LOADING = 'SET_BASIC_CONFIG_LOADING';
export const SET_BASIC_CONFIG = 'SET_BASIC_CONFIG';
